import { Facility } from '../../types/Facility';
import { dateHeader, formatCellDate } from './timeModeCell';
import GridAction from '../../components/common/GridAction';
import MyLocationOutlined from '@mui/icons-material/MyLocationOutlined';
import { ViewTimelineTwoTone } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { AppPermissions } from '../../constants/Permissions';

export const makeFacilityListColumn = (
  onDeleted: (id: string) => void,
  onEdit: (facility: Facility) => void,
  onOpenChangeLog: (id: string) => void
) => {
  return [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 75,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const { id } = row.original as Facility;
        return (
          <GridAction
            onEdit={onEdit}
            editPermission={AppPermissions.Facility.Edit}
            onDeleted={onDeleted}
            deletePermission={AppPermissions.Facility.Delete}
            row={row.original}
            id={id}
          >
            {' '}
            <Tooltip style={{ cursor: 'pointer' }} title='Show Changelog' disableInteractive onClick={() => onOpenChangeLog(id)}>
              <ViewTimelineTwoTone fontSize='small' />
            </Tooltip>
          </GridAction>
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 350,
      cell: ({ row }) => <span title={row.original.name}>{row.original.name}</span>,
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 75,
      style: { textAlign: 'center' },
    },
    {
      header: 'Type',
      accessorKey: 'facilityType',
      disableSortBy: true,
      size: 100,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return <>{row.original.facilityTypeDescr ?? ''}</>;
      },
    },
    {
      header: 'Carriers',
      accessorKey: 'carrier.iatacode',
      size: 100,
      style: { textAlign: 'center' },
      enableColumnFilter: true,
      cell: ({ row }) => {
        const carriers = row.original.carriers ?? [];
        return <>{carriers.map((c) => c.carrierCode).join(', ')}</>;
      },
    },
    {
      header: 'Latitude',
      accessorKey: 'location.latitude',
      disableSortBy: true,
      size: 110,
      style: { textAlign: 'center' },
    },
    {
      header: 'Longitude',
      accessorKey: 'location.longitude',
      disableSortBy: true,
    },
    {
      header: 'Fence',
      accessorKey: 'geofenceCount',
      style: { textAlign: 'center' },
      disableSortBy: true,
      size: 55,
      cell: ({ row }) => {
        return (
          <MyLocationOutlined
            fontSize='small'
            style={{ marginLeft: 10, color: row.original.geofenceCount && row.original.geofenceCount > 0 ? 'red' : 'black' }}
          />
        );
      },
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 'auto',
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;
};
